import { render } from "./SinglePartner.vue?vue&type=template&id=706d19d0&scoped=true"
import script from "./SinglePartner.vue?vue&type=script&lang=js"
export * from "./SinglePartner.vue?vue&type=script&lang=js"

import "./SinglePartner.vue?vue&type=style&index=0&id=706d19d0&lang=scss"
import "./SinglePartner.vue?vue&type=style&index=1&id=706d19d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706d19d0"]])

export default __exports__